import List from "components/Admin/Norms/Group/List/QuestionnaireList"
import React from "react"

const ListQuestionnairePage = () => {
    return (
        <React.Fragment>
            <List />
        </React.Fragment>
    )
}
export default ListQuestionnairePage
